import Image from "next/image";

type CustomToastProps = {
  message: string;
};
export default function CustomToast({ message }: CustomToastProps) {
  return (
    <>
      <div className="px-5 py-2.5 bg-gray-700 rounded-lg inline-flex">
        <div className="w-6 h-6 relative flex-col justify-start items-start flex">
          <div className="w-5 h-5 relative">
            <Image src="/icons/Check-Circle.svg" alt="" fill={true} />
          </div>
        </div>
        <div className="text-white text-sm font-medium leading-normal">
          {message}
        </div>
      </div>
    </>
  );
}
